import { render, staticRenderFns } from "./returnManagement.vue?vue&type=template&id=3d7b6b3c&scoped=true"
import script from "./returnManagement.vue?vue&type=script&lang=js"
export * from "./returnManagement.vue?vue&type=script&lang=js"
import style0 from "./returnManagement.vue?vue&type=style&index=0&id=3d7b6b3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7b6b3c",
  null
  
)

export default component.exports